import React, { useCallback, useEffect, useMemo, useState } from 'react';
import I18nContext from './context';
import { i18nUtils } from './utils';
import bg from './translations/bg';
import en from './translations/en';

const TRANSLATIONS = { bg, en };

export const I18nProvider = ({ children, initialLanguage }) => {
  const [language, setLanguageState] = useState(
    initialLanguage || i18nUtils.getInitialLanguage()
  );

  useEffect(() => {
    if (!i18nUtils.SUPPORTED_LANGUAGES.includes(language)) {
      setLanguageState(i18nUtils.DEFAULT_LANGUAGE);
    }
  }, [language]);

  const setLanguage = useCallback((lang) => {
    if (!lang || !i18nUtils.SUPPORTED_LANGUAGES.includes(lang)) return;
    setLanguageState(lang);
    i18nUtils.storeLanguage(lang);
    try {
      const event = new CustomEvent('i18n:languageChanged', { detail: { language: lang } });
      window.dispatchEvent(event);
    } catch (e) {
      // ignore
    }
  }, []);

  const translations = useMemo(() => TRANSLATIONS[language] || {}, [language]);

  const t = useCallback((key, params, opts) => {
    return i18nUtils.translate(translations, key, params, { language, ...(opts || {}) });
  }, [translations, language]);

  const value = useMemo(() => ({ language, translations, t, setLanguage }), [language, translations, t, setLanguage]);

  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
};

export default I18nProvider;

export { TRANSLATIONS };


